import { useState } from 'react';

import { Seg } from '../../components/ui';
import type { TtsProvider } from '../../types/api';
import { AccountVoicesTab } from './AccountVoicesTab';
import { VoiceLibraryTab } from './VoiceLibraryTab';
import styles from './VoicesPage.module.css';

type TabKey = 'ours' | 'library';

const PROVIDER_LABELS: Readonly<Record<TtsProvider, string>> = {
  elevenlabs: 'ElevenLabs',
  cartesia: 'Cartesia',
};

export function VoicesPage() {
  const [provider, setProvider] = useState<TtsProvider>('elevenlabs');
  const [tab, setTab] = useState<TabKey>('ours');

  const hasLibrary = provider === 'elevenlabs';
  const shown: TabKey = hasLibrary ? tab : 'ours';

  const pickProvider = (next: TtsProvider) => {
    setProvider(next);
    if (next !== 'elevenlabs') setTab('ours');
  };

  return (
    <div className={styles.page}>
      <Seg
        className={styles.tabs}
        value={provider}
        onChange={pickProvider}
        ariaLabel="Провайдер голосов"
        options={[
          { value: 'elevenlabs', label: PROVIDER_LABELS.elevenlabs },
          { value: 'cartesia', label: PROVIDER_LABELS.cartesia },
        ]}
      />

      {hasLibrary && (
        <Seg
          className={styles.tabs}
          value={shown}
          onChange={setTab}
          ariaLabel="Разделы голосов"
          options={[
            { value: 'ours', label: 'Наши голоса' },
            { value: 'library', label: `Библиотека ${PROVIDER_LABELS[provider]}` },
          ]}
        />
      )}

      {shown === 'ours' ? (
        <AccountVoicesTab provider={provider} />
      ) : (
        <VoiceLibraryTab onOpenOurs={() => setTab('ours')} />
      )}
    </div>
  );
}
